import { FETCH_PROCESSING_DEALS_STATUS, SET_PROCESSING_DEALS_STATUS } from '../actions/ActionTypes';
import { UNINITIALIZED, SUCCEEDED } from '../constants/RequestStatusTypes';
import { buildTypedMap } from '../types/TypedMap';
const initialState = buildTypedMap({
  status: UNINITIALIZED,
  isProcessingDeals: false
});
export default function automation(state = initialState, action) {
  const {
    payload
  } = action;
  switch (action.type) {
    case FETCH_PROCESSING_DEALS_STATUS:
      return state.merge({
        status: SUCCEEDED,
        isProcessingDeals: payload
      });
    case SET_PROCESSING_DEALS_STATUS:
      return state.set('isProcessingDeals', payload);
    default:
      return state;
  }
}